import React from 'react';
import PropTypes from 'prop-types';
import {GelBand} from '../GelBand';
import {GEL_TYPE} from '../GelDragDrop.constants';
import {GelDragDropContext} from '../GelDragDrop.utils';

export function GelHolder(props) {
  const {state, onDragOver, onStripDrop, isMultiGelHolder} = React.useContext(
    GelDragDropContext
  );

  const style = {height: `${state.gelHolderBoxHeight}px`};

  const isLabelColumn = (gel) => gel.gelType === GEL_TYPE.LABEL;

  const setInnerText = (gel) => {
    let text = null;
    if (isLabelColumn(gel)) text = `${gel.value} bp`;
    if (isMultiGelHolder) text = `${gel.gelId + 1}`;
    return text;
  };

  const renderGelBand = (gelBand) => (
    <GelBand
      key={gelBand.gelId}
      gelId={`${props.cellId}_${gelBand.gelId}`}
      gelType={gelBand.gelType}
      height={gelBand.height}
      opacity={gelBand.opacity}
      value={gelBand.value}
      className={`${props.className}__gelBox__band`}
      selected={gelBand.selected}>
      {setInnerText(gelBand)}
    </GelBand>
  );

  const renderContent = () => {
    if (props.cellItems) {
      return (
        <div className={`${props.className}__gelBox`} style={style}>
          {props.cellItems.map(renderGelBand)}
        </div>
      );
    } else {
      return (
        <p className={`${props.className}__label`} style={style}>
          {props.label}
        </p>
      );
    }
  };

  const onDrop = (event) => {
    onStripDrop({event, cellId: props.cellId, value: 0});
  };

  return (
    <div className={props.className} onDragOver={onDragOver} onDrop={onDrop}>
      {renderContent()}
    </div>
  );
}

GelHolder.propTypes = {
  /**
   * ClassName to be set for the cell;
   */
  className: PropTypes.string,
  /**
   * label to display on gel holder
   */
  label: PropTypes.string,
  /**
   * Unique Id for the cell
   */
  cellId: PropTypes.string,
  /**
   * List of GelItems to be renderd here
   */
  cellItems:
    PropTypes.arrayOf(
      PropTypes.shape({
        /**
         * Unique Id for Gel
         */
        gelId: PropTypes.number,
        /**
         * Type of Gel-Strip
         */
        gelType: PropTypes.oneOf(Object.keys(GEL_TYPE)),
        /**
         * Height value go Gel
         */
        height: PropTypes.number,
        /**
         * Opacity value of Gel
         */
        opacity: PropTypes.number,
        /**
         * Postion value of Gel
         */
        value: PropTypes.number || null,
        /**
         * Boolean to set if gel band is selected
         */
        selected: PropTypes.bool,
      })
    ) || null,
};

GelHolder.defaultProps = {
  label: null,
};
